import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

interface FailedExecutionsAlertProps {
  count: number;
}

export function FailedExecutionsAlert({ count }: FailedExecutionsAlertProps) {
  if (count === 0) return null;

  return (
    <div className="flex items-center gap-3 rounded-lg border border-danger-500/25 bg-danger-500/10 px-4 py-3">
      <AlertTriangle className="h-5 w-5 shrink-0 text-danger-500" />
      <div className="flex-1">
        <p className="text-sm font-medium text-danger-400">
          {count} exécution(s) en échec dans les 24 dernières heures
        </p>
      </div>
      <Link to="/automations?status=failed" className="text-xs font-medium text-danger-400 hover:text-danger-300 underline">
        Voir
      </Link>
    </div>
  );
}
